'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _Constant = require('helpers/Constant');

var _Constant2 = _interopRequireDefault(_Constant);

var _lodash = require('lodash');

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _address = require('redux/modules/address');

var addressActions = _interopRequireWildcard(_address);

var _components = require('components');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _support = require('helpers/support');

var _lib = require('helpers/lib');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import ReactGA from 'react-ga';
var ExchangePromotionScreen = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    ALL_REWARD_LIST: state.voucher.ALL_REWARD_LIST,
    REWARD_LIST_NO_STAR: state.voucher.REWARD_LIST_NO_STAR,
    REWARD_LIST_FIVE_STAR: state.voucher.REWARD_LIST_FIVE_STAR,
    voucherFilters: state.voucher.voucherFilters,
    voucherFilterChosen: state.voucher.voucherFilterChosen,
    submit: state.shops.submit,
    shop: state.shops.shop,
    districts: state.address.districts,
    district: state.address.district
  };
}, {
  getAllReward: voucherActions.getAllReward,
  beforeExchangeReward: voucherActions.beforeExchangeReward,
  exchangeReward: voucherActions.exchangeReward,
  getMyReward: voucherActions.getMyReward,
  changeVoucherFilter: voucherActions.changeVoucherFilter,
  resetBooking: bookingActions.resetBooking,
  setDefaultBooking: bookingActions.setDefaultBooking,
  changeShopBeforeBooking: bookingActions.changeShopBeforeBooking,
  loadDistrict: addressActions.loadDistrict,
  changeDistrict: addressActions.changeDistrict,
  showDownloadAppPopup: setupActions.showDownloadAppPopup,
  setPathName: _setup.setPathName
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExchangePromotionScreen, _Component);

  function ExchangePromotionScreen(props) {
    (0, _classCallCheck3.default)(this, ExchangePromotionScreen);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ExchangePromotionScreen.__proto__ || (0, _getPrototypeOf2.default)(ExchangePromotionScreen)).call(this, props));

    _this.showDistrict = function () {
      var districts = _this.props.districts;

      if (districts) {
        _this.setState({ showDistrict: true });
      }
    };

    _this.hideDistrict = function () {
      _this.setState({ showDistrict: false });
    };

    _this.onChangeDistrict = function (district) {
      _this.props.changeDistrict(district);
    };

    _this.onClearDistrict = function () {
      _this.props.changeDistrict({});
    };

    _this.renderAllService = _this.renderAllService.bind(_this);
    _this.state = {
      showErr: false,
      contentErr: {
        title: { text: 'Lỗi', type: 'error' },
        message: []
      },
      showFlow: false,
      contentFlow: {
        title: { text: 'Thông Báo', type: 'success' },
        message: []
      },
      showOption: false,
      service: null,
      showFilter: false,
      showDistrict: false
    };
    _this.toBooking = _this.toBooking.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ExchangePromotionScreen, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.ALL_REWARD_LIST.data.length === 0) {
        this.props.getAllReward({ pageSize: 1000 });
      }
      if (this.props.route.path === 'uu-dai-trai-nghiem') {
        this.props.changeVoucherFilter('Ưu đãi trải nghiệm');
      } else if (this.props.route.path === 'uu-dai-5-sao') {
        this.props.changeVoucherFilter('Ưu đãi 5 sao');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(this.props.district, nextProps.district)) {
        this.props.getAllReward({
          pageSize: 1000,
          district: nextProps.district.code
        });
      }
    }
  }, {
    key: 'downApp',
    value: function downApp(platform) {
      if (platform === 'ios') {
        window.location.assign(_config2.default.iosLink);
      }
      if (platform === 'android') {
        window.location.assign(_config2.default.androidLink);
      }
    }
  }, {
    key: 'getButtonExchangeReward',
    value: function getButtonExchangeReward(_ref) {
      var _this2 = this;

      var type = _ref.type,
          reward = _ref.reward;

      switch (type) {
        case 'EXCHANGE_REWARD_SUCCESS':
          return [this.getButtonByShop(reward.couponCode), {
            text: 'Ưu Đãi Của Tôi',
            onClick: function onClick() {
              _this2.hideFlow();
              _this2.toMyReward();
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        case 'REWARD_EXISTED':
          return [this.getButtonByShop(reward.couponCode), {
            text: 'Chi Tiết Ưu Đãi',
            onClick: function onClick() {
              return _this2.toBookingReward(reward.couponCode.code);
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        case 'EXCHANGE_REWARD_FAIL':
          return [{
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideError();
            }
          }];
        case 'CONFIRM_EXCHANGE_REWARD':
          return [{
            text: 'Chắc chắn',
            onClick: function onClick() {
              _this2.hideFlow();
              _this2.exchange(reward);
              _reactGa2.default.event({
                category: 'Promotion',
                action: 'Clicked Exchange button',
                label: '' + reward.packId
              });
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        case 'REQUIRE_LOGIN':
          return [{
            text: 'Đăng nhập',
            onClick: function onClick() {
              _this2.hideFlow();
              _this2.toLogin();
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        case 'REWARD_FOR_APP':
          return [{
            iconFont: 'fa fa-apple fa-3x',
            text: 'IOS',
            onClick: function onClick() {
              _this2.downApp('ios');
            }
          }, {
            iconFont: 'fa fa-android fa-3x',
            text: 'Android',
            onClick: function onClick() {
              _this2.downApp('android');
            }
          }];
        default:
          break;
      }
      return [];
    }
  }, {
    key: 'getButtonByShop',
    value: function getButtonByShop(coupon) {
      var _this3 = this;

      if (coupon && coupon.packageService) {
        var shop = coupon.packageService.shop;

        var btn = {};
        if (shop && shop.isBooking) {
          btn = {
            text: 'Đặt Lịch',
            onClick: function onClick() {
              _this3.hideFlow();
              _this3.toBooking(coupon);
            }
          };
        } else if (shop && !shop.isBooking) {
          btn = {
            text: 'Gọi Đặt Lịch',
            onClick: function onClick() {
              _this3.hideFlow();
              _this3.toCallShop(shop);
            }
          };
        }
        return btn;
      }
      return {};
    }
  }, {
    key: 'exchange',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(item) {
        var exchangeReward, res, content, couponCode;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                exchangeReward = this.props.exchangeReward;
                _context.next = 3;
                return exchangeReward(item);

              case 3:
                res = _context.sent;
                content = {};

                if (res.success) {
                  couponCode = res.couponCode;

                  if (res.type === 'TO_BOOKING') {
                    this.toBooking(couponCode);
                  } else {
                    content = res.content;
                    content.button = this.getButtonExchangeReward({
                      type: res.type,
                      reward: res.data
                    });
                    this.setState({ contentFlow: content, showFlow: true });
                  }
                } else {
                  content = res.content;
                  content.button = this.getButtonExchangeReward({
                    type: res.type,
                    reward: res.data
                  });
                  this.setState({ contentErr: content, showErr: true });
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function exchange(_x) {
        return _ref2.apply(this, arguments);
      }

      return exchange;
    }()
  }, {
    key: 'onExchange',
    value: function onExchange(e, item) {
      e.stopPropagation();
      this.props.showDownloadAppPopup();
      // const res = this.props.beforeExchangeReward(item);
      // if (res.type === 'REQUIRE_EXCHANGE_SHOP') {
      //   this.props.history.push(`/uu-dai/${item.handle}?branch=true`);
      // } else {
      //   const contentFlow = { ...res.content };
      //   contentFlow.button = this.getButtonExchangeReward({
      //     type: res.type,
      //     reward: res.data,
      //   });
      //   this.setState({ contentFlow, showFlow: true });
      // }
    }
  }, {
    key: 'toLogin',
    value: function toLogin() {
      this.props.setPathName('/uu-dai');
      this.props.history.push('/dang-nhap');
    }
  }, {
    key: 'toBooking',
    value: function toBooking(coupon) {
      this.props.showDownloadAppPopup();
      // const {
      //   packageService: { shop, service },
      //   code,
      // } = coupon;
      // const {
      //   resetBooking,
      //   setDefaultBooking,
      //   history,
      //   changeShopBeforeBooking,
      //   user,
      // } = this.props;
      // resetBooking();
      // changeShopBeforeBooking(shop, user);
      // const bookingServices = [
      //   { service: service._id, number: 1, name: service.name },
      // ];
      // const submit = { bookingServices, code, shop, coupon };
      // setDefaultBooking(submit);
      // history.push(`/dat-lich`);
    }
  }, {
    key: 'toCallShop',
    value: function toCallShop(shop) {
      if (shop) {
        window.open('tel:' + (0, _lib.getPhone)(shop.phone));
      }
    }
  }, {
    key: 'toMyReward',
    value: function toMyReward() {
      this.props.changeTab('myReward');
    }
  }, {
    key: 'toRewardDetail',
    value: function toRewardDetail(item) {
      this.props.history.push('/uu-dai/' + item.handle);
      _reactGa2.default.event({
        category: 'Promotion',
        action: 'Clicked Voucher Card from All Reward',
        label: '' + item.packId
      });
    }
  }, {
    key: 'toBookingReward',
    value: function toBookingReward(code) {
      this.props.history.push('/uu-dai-cua-toi/' + code);
    }
  }, {
    key: 'showError',
    value: function showError() {
      this.setState({ showErr: true });
    }
  }, {
    key: 'hideError',
    value: function hideError() {
      this.setState({ showErr: false });
    }
  }, {
    key: 'showFlow',
    value: function showFlow() {
      this.setState({ showFlow: true });
    }
  }, {
    key: 'hideFlow',
    value: function hideFlow() {
      this.setState({ showFlow: false });
    }
  }, {
    key: 'toRewardDetail',
    value: function toRewardDetail(item) {
      this.props.history.push('/uu-dai/' + item.handle);
      _reactGa2.default.event({
        category: 'Promotion',
        action: 'Clicked Voucher Card from All Reward',
        label: '' + item.packId
      });
    }
  }, {
    key: 'renderAllService',
    value: function renderAllService(service, i) {
      var _this4 = this;

      var user = this.props.user;

      var userNo = _support.Helper.rankNo(user ? user.rank : null);
      var _item = _support.Helper.parsePackageServiceToCard(service);
      if (_item.forRank && _item.forRank.type && userNo !== -1) {
        var campaignNo = _support.Helper.rankNo(_item.forRank.type);
        _item.allowExchange = userNo >= campaignNo;
      }
      return _react2.default.createElement(_components.RewardItemSmall, {
        key: 'serviceItem_' + i,
        item: _item,
        onPress: function onPress() {
          return _this4.toRewardDetail(_item);
        },
        onExchange: function onExchange(e) {
          return _this4.onExchange(e, _item);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          history = _props.history,
          homeOff = _props.homeOff,
          REWARD_LIST_NO_STAR = _props.REWARD_LIST_NO_STAR,
          REWARD_LIST_FIVE_STAR = _props.REWARD_LIST_FIVE_STAR,
          user = _props.user,
          route = _props.route,
          voucherFilters = _props.voucherFilters,
          voucherFilterChosen = _props.voucherFilterChosen,
          districts = _props.districts,
          district = _props.district;
      // const { showFilter } = this.state;

      var data = route.page === 'PromotionFiveStar' ? REWARD_LIST_FIVE_STAR.data : REWARD_LIST_NO_STAR.data;
      var _state = this.state,
          showErr = _state.showErr,
          contentErr = _state.contentErr,
          showFlow = _state.showFlow,
          contentFlow = _state.contentFlow,
          showDistrict = _state.showDistrict;

      var styles = require('./ExchangePromotionScreen.scss');
      var hideCategory = true;
      var botInfo = null;
      if (user && user.rank) {
        botInfo = _Constant2.default.RANK[user.rank];
        botInfo.pointReward = user.rewardPoints;
      }
      return _react2.default.createElement(
        'div',
        { className: styles.allReward },
        !hideCategory && _react2.default.createElement(
          'div',
          { className: styles.slider },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-cham-soc-da-massage' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.massageIcon }),
              'Ch\u0103m S\xF3c Da/Massage'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-lam-toc-mong' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.hairIcon }),
              'L\xE0m T\xF3c/M\xF3ng'
            )
          ),
          !homeOff && _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-dich-vu-tai-nha' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.homeServiceIcon }),
              'L\xE0m \u0110\u1EB9p T\u1EA1i Nh\xE0'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-tham-my-vien' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.cosmeticIcon }),
              'Th\u1EA9m M\u1EF9 Vi\u1EC7n'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-phong-kham' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.clinicIcon }),
              'Ph\xF2ng Kh\xE1m'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-the-duc-the-thao' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.fitnessIcon }),
              'Th\u1EC3 D\u1EE5c Th\u1EC3 Thao'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.groupFilter },
          _react2.default.createElement(_components.VoucherFilterBar, {
            className: styles.voucherFilterBar,
            voucherFilterChosen: voucherFilterChosen,
            voucherFilters: voucherFilters,
            history: history,
            route: route,
            changeVoucherFilter: this.props.changeVoucherFilter
          }),
          _react2.default.createElement(_components.SelectShop, {
            isBookingAddress: true,
            show: showDistrict,
            data: districts,
            activeShop: district,
            placeHolder: 'Qu\u1EADn huy\u1EC7n',
            titleOverlay: 'Ch\u1ECDn qu\u1EADn huy\u1EC7n',
            onHide: this.hideDistrict,
            onShow: this.showDistrict,
            onChange: this.onChangeDistrict,
            className: styles.selectAddress,
            onClear: this.onClearDistrict,
            small: true
          })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.listVoucher },
          !!(data && data.length) ? data.map(function (ser, i) {
            return _this5.renderAllService(ser, i);
          }) : _react2.default.createElement(
            'div',
            { className: styles.nodata },
            'Hi\u1EC7n t\u1EA1i ch\u01B0a c\xF3 khuy\u1EBFn m\xE3i n\xE0o!'
          )
        ),
        botInfo && _react2.default.createElement(_components.BottomInfoUser, { data: botInfo }),
        _react2.default.createElement(_components.ModalCustom, {
          key: 'modal_flow',
          show: showFlow,
          onHide: function onHide() {
            return _this5.hideFlow();
          },
          title: contentFlow.title,
          message: contentFlow.message,
          button: contentFlow.button,
          closeButton: true
        }),
        _react2.default.createElement(_components.ModalCustom, {
          key: 'modal_error',
          show: showErr,
          onHide: this.hideError,
          title: contentErr.title,
          message: contentErr.message,
          button: contentErr.button,
          closeButton: true
        })
      );
    }
  }]);
  return ExchangePromotionScreen;
}(_react.Component), _class2.propTypes = {
  // @data
  // userNo: PropTypes.number,
  user: _react.PropTypes.object,
  history: _react.PropTypes.object,
  configHeader: _react.PropTypes.object,
  route: _react.PropTypes.object,
  ALL_REWARD_LIST: _react.PropTypes.object,
  REWARD_LIST_NO_STAR: _react.PropTypes.object,
  REWARD_LIST_FIVE_STAR: _react.PropTypes.object,
  submit: _react.PropTypes.object,
  shop: _react.PropTypes.object,
  district: _react.PropTypes.object,
  voucherFilters: _react.PropTypes.array,
  districts: _react.PropTypes.array,
  voucherFilterChosen: _react.PropTypes.string,
  // dynamicData: PropTypes.object,
  homeOff: _react.PropTypes.bool,
  // @action
  getAllReward: _react.PropTypes.func,
  // getRewardAtHome: PropTypes.func,
  // getRewardAtSpa: PropTypes.func,
  beforeExchangeReward: _react.PropTypes.func,
  exchangeReward: _react.PropTypes.func,
  changeTab: _react.PropTypes.func,
  setPathName: _react.PropTypes.func,
  setDefaultBooking: _react.PropTypes.func,
  resetBooking: _react.PropTypes.func,
  // getMyReward: PropTypes.func,
  changeShopBeforeBooking: _react.PropTypes.func,
  loadServiceOfHomeService: _react.PropTypes.func,
  changeService: _react.PropTypes.func,
  changeVoucherFilter: _react.PropTypes.func,
  loadDistrict: _react.PropTypes.func,
  changeDistrict: _react.PropTypes.func,
  showDownloadAppPopup: _react.PropTypes.func
}, _temp)) || _class);
exports.default = ExchangePromotionScreen;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/ExchangePromotionScreen.js
// module id = 1625
// module chunks = 0